import Rebase from 're-base';

const base = Rebase.createClass({
  apiKey: "AIzaSyCvgd6dthExAxTWbpMcEXET02vMIuNGATQ",
  authDomain: "catch-of-the-day-rgan.firebaseapp.com",
  databaseURL: "https://catch-of-the-day-rgan.firebaseio.com"
});

export default base;



/** WEBPACK FOOTER **
 ** ./src/base.js
 **/